import { usePeriodName } from '@app/src/hooks/usePeriodName'
import { DeviationIcon } from '@app/src/pages/Questionnaire/DeviationIcon'
import { useReport } from '@app/src/pages/Questionnaire/ReportContext'
import type { ResponseItem } from '@app/src/types/resourceExplorer'
import { calculateDeviation } from '@app/src/utils/deviationCalculator'
import { numberIsSet } from '@app/src/utils/helpers'
import { formatNumber } from '@app/src/utils/helpersTs'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface DeviationIndicatorProps {
  selectedValue: string | number | undefined
  unitSymbol: string | null | undefined
  answersToThisQuestion: ResponseItem[]
}

export const DeviationIndicator: React.FC<DeviationIndicatorProps> = ({
  unitSymbol,
  answersToThisQuestion,
  selectedValue,
}) => {
  const { request } = useReport()
  const { formatMessage } = useIntl()
  const { formatPeriodName } = usePeriodName()

  const deviationResult = calculateDeviation(
    selectedValue,
    answersToThisQuestion,
    request?.periodName,
    request?.questionnaireTemplateId,
  )
  if (!deviationResult) return null

  const textColor =
    !numberIsSet(deviationResult.deviation) || deviationResult.deviation === 0 ? 'textSecondary' : undefined

  return (
    <Stack width="50%" direction="row" pl={2}>
      <DeviationIcon deviation={deviationResult?.deviation} />
      <Stack direction="column">
        <Typography variant="subtitle1" color={textColor}>
          {numberIsSet(deviationResult.deviation)
            ? formatMessage({ id: 'deviation.standard' }, { deviation: formatNumber(deviationResult?.deviation, 20) })
            : formatMessage({
                id: 'deviation.notApplicable',
              })}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {formatMessage(
            { id: 'deviation.comparedToPeriod' },
            { periodName: formatPeriodName(deviationResult.previousAnswerPeriod) },
          )}
        </Typography>
        {formatNumber(deviationResult?.previousAnswer, 20)} {unitSymbol ?? ''}
      </Stack>
    </Stack>
  )
}
